// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {open_popup_cb, perr, get_user_sync_token} from 'hola_pub_util';
import {guess} from 'zuser_agent';
import login_config from 'login_config';
import zescape from '/util/escape.js';
import {t_login_process_status, t_states} from './types';
import {Model} from '../../lib/model';
import etask from 'zetask';
import {is_valid_email, qs_parse_url, qs_parse, add_proto, parse} from 'zurl';
import hopt from 'hola_opt';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import recaptcha from '../../recaptcha.js';
import cookie from 'cookie';
import storage from '/util/storage.js';
import {get_user} from 'hola_pub_util';

export const up = login_config.url_prefix+'/users';

let be;

export const set_be = _be=>{ be = _be; };

class Login_process extends Model {
    state:t_login_process_status = 'ready';
    active_process: etask_t = null;
    last_process_error = '';
    last_email = '';
    recaptcha_stuck: any;
    recaptcha_long_stuck: any;
    captcha_interval: any;
    recaptcha_inited = false;

    change_status = (new_status:t_login_process_status)=>{
        this.state = new_status;
        this.notify('state_changed');
    };
    change_last_process_error = (new_status:string)=>{
        this.last_process_error = new_status;
        this.notify('last_process_error_changed');
    };
    social_click = (name: string, enc_url: string)=>{
        enc_url = enc_url||'';
        if (enc_url && enc_url[0]!='?')
            enc_url = '?'+enc_url;
        const qs = qs_parse_url(location.href, {safe: true});
        const open_popup = !guess().mobile && !qs.signin_redirect;
        const href = ()=>up+'/auth/'+name+enc_url;
        const href_popup = up+'/auth/'+name+'/popup'+enc_url;
        perr({id: 'www_social_click', info: {open_popup, enc_url}});
        if (!open_popup)
            return location.href = href();
        const popup = open_popup_cb(href_popup);
        if (!popup)
        {
            // firefox prevents opening popup so open it in current
            // tab & redirect
            if (qs.root_url)
            {
                const qs_o = qs_parse(enc_url.substring(1), {safe: true});
                enc_url = '?'+zescape.qs({...qs_o,
                    next: add_proto(qs.root_url)});
            }
            perr({id: 'www_social_click_fallback', info: {enc_url}});
            return top.location.href = href();
        }
    };
    validate_password = (password:string, is_login=false)=>{
        if (password=='')
            return 'empty_password';
        if (password.length < 8 && !is_login)
            return 'short_password';
        return '';
    };
    init_recaptcha = ()=>{
        if (hopt.mtcaptcha && hopt.mtcaptcha.enable)
            return;
        if (this.recaptcha_inited)
            return;
        this.recaptcha_inited = true;
        perr({id: `www_recaptcha_init`});
        clearTimeout(this.recaptcha_long_stuck);
        // @ts-ignore
        recaptcha.render(document.getElementById('recaptcha_root'),
            this.on_recaptcha_challenge);
    };
    on_recaptcha_challenge = action=>{
        clearTimeout(this.recaptcha_stuck);
        perr({id: `www_${action}_recaptcha_challenge_show`,
            info: {email: this.last_email}});
        this.recaptcha_long_stuck = setTimeout(()=>{
            perr({id: `www_${action}_stuck_recaptcha_challenge`});
        }, 30000);
    };
    get_token = ()=>{
        let _this = this;
        return etask(function*(){
            // @ts-ignore
            let token = window.mtcaptcha.getVerifiedToken(
                // @ts-ignore
                window.global_captcha.mtcaptcha_generic_class);
            // @ts-ignore
            const captcha_st = window.mtcaptcha.getStatus(
                // @ts-ignore
                window.global_captcha.mtcaptcha_generic_class
            );
            if (!token && !captcha_st.isVisible)
            {
                const captcha_task = etask.wait();
                // @ts-ignore
                window.mtcaptcha.resetUI(
                    // @ts-ignore
                    window.global_captcha.mtcaptcha_generic_class
                );
                _this.captcha_interval = setInterval(()=>{
                    // @ts-ignore
                    token = window.mtcaptcha.getVerifiedToken();
                    if (token)
                    {
                        clearInterval(_this.captcha_interval);
                        captcha_task.continue();
                    }
                    // @ts-ignore
                    const interval_st = window.mtcaptcha.getStatus();
                    if (interval_st.isVisible)
                    {
                        clearInterval(_this.captcha_interval);
                        captcha_task.continue();
                    }
                }, 1000);
                yield captcha_task;
            }
            return token;
        });
    };
    check_password = (email, password)=>{
        let _this = this;
        return etask(function*(){
            let res;
            try {
                const {ignore_countries} = hopt.recaptcha || {};
                const mtcaptcha = hopt.mtcaptcha;
                let token;
                let type_c = 'google';
                if (mtcaptcha.enable)
                {
                    // @ts-ignore
                    if (!window.mtcaptcha)
                    {
                        const err = new Error();
                        // @ts-ignore
                        err.hola_info = {
                            response_text: 'load_recaptcha',
                            status: 401,
                        };
                        throw err;
                    }
                    token = yield _this.get_token();
                    type_c = 'mtcaptcha';
                    if (!token)
                    {
                        const err = new Error();
                        // @ts-ignore
                        err.hola_info = {
                            response_text: 'recaptcha',
                            status: 401,
                        };
                        throw err;
                    }
                }
                else if (!ignore_countries
                    || ignore_countries.indexOf(hopt.user_country)==-1)
                {
                    clearTimeout(_this.recaptcha_stuck);
                    _this.recaptcha_stuck = setTimeout(()=>{
                        perr({id: 'www_login_stuck_recaptcha'});
                    }, 10000);
                    // @ts-ignore
                    token = yield recaptcha.new_token('login');
                    clearTimeout(_this.recaptcha_stuck);
                    clearTimeout(_this.recaptcha_long_stuck);
                }
                const check_pass_strength = ()=>
                etask(function*(){
                    try {
                        const check_res = yield fetch('/users/check_pass', {
                            method: 'POST',
                            body: {
                                pass: password,
                                email
                            },
                        });
                        return check_res;
                    } catch {}
                });
                let pass_strength = yield check_pass_strength();
                res = yield fetch(up+'/auth/basic/check_credentials', {
                    method: 'POST',
                    body: {username: email, password: password,
                        recaptcha: token, type_c: type_c, pass_strength},
                });
            } catch(e){
                if (e.hola_info && e.hola_info.status===401)
                    return e.hola_info.response_text||false;
                throw e;
            }
            return res=='ok' ? true : res;
        });
    };
    login_done = (email:string, get_enc_url:()=>string)=>{
        let _this = this;
        return etask(function*(){
            perr({id: 'www_login_success', info: {email}});
            let login_res = yield fetch(up+'/auth/basic/login'+get_enc_url());
            if (_this.has_event_listener('on_login'))
                return void _this.notify('on_login');
            if (!login_res || !login_res.next)
                return;
            // signin_redirect means that we are going to redirect to the
            // target site (eg netflix.com) so we won't call
            // refresh_membership on hola.org reload
            if (be)
            {
                if (qs_parse_url(location.href, {safe: true}).signin_redirect)
                {
                    // @ts-ignore
                    yield be.refresh_membership();
                    yield etask.sleep(1000);
                }
                yield _this.make_local_redirect(login_res);
                if (login_res.next && login_res.next.indexOf('chrome:')==0)
                    login_res.next = 'https://hola.org';
            }
            location.href = login_res.next;
        });
    };
    make_local_redirect = login_res=>{
        const qs_o = qs_parse_url(location.href, {safe: true});
        const local_r = decodeURIComponent(qs_o.local_redirect||'');
        const hash = qs_o.hash;
        const local_r_u = parse(local_r);
        if (local_r && (local_r_u.protocol!='http:' ||
            local_r_u.hostname!='127.0.0.1'))
        {
            login_res.next = 'https://hola.org';
            return;
        }
        if (!local_r || !hash)
            return;
        const id = (cookie.getJSON('user') || {})._id || '';
        if (!id)
            return;
        return etask(function*(){
            try {
                const sync_token = yield get_user_sync_token(hash);
                login_res.next = `${local_r}?ott=${sync_token}`;
            } catch {}
        });
    };
    login_with_email = (email: string, password: string,
        get_enc_url: ()=>string)=>
    {
        perr({id: 'www_login_click', info: {email}});
        this.last_email = email;
        const _this = this;
        this.active_process = etask(function*(){
            try {
                if (!is_valid_email(email))
                    return;
                if (_this.validate_password(password, true))
                    return;
                _this.change_last_process_error('');
                _this.change_status('in_progress');
                let ret = yield _this.check_password(email, password);
                if (ret=='not_registered')
                {
                    _this.change_last_process_error('not_registered');
                    _this.change_status('ready');
                    return;
                }
                if (ret=='unauthorized')
                {
                    _this.change_last_process_error('wrong_password');
                    _this.change_status('ready');
                    return;
                }
                if (['change_password', 'account_blocked', 'abuse_ip',
                    'recaptcha', 'load_recaptcha']
                    .includes(ret))
                {
                    _this.change_last_process_error(ret);
                    _this.change_status('ready');
                    return;
                }
                if (ret=='unverified_two_step')
                {
                    _this.change_status('waiting_for_two_step');
                    return;
                }
                if (ret!==true)
                {
                    _this.change_last_process_error('unknown');
                    _this.change_status('ready');
                    return;
                }
                yield _this.login_done(email, get_enc_url);
            } catch(e){
                if (e=='recaptcha_cancel')
                    return void _this.change_status('ready');
                console.error(e);
                _this.change_last_process_error('unknown');
                _this.change_status('ready');
            }
        });
    };
    create_new_account = (email: string, password: string, news: boolean,
        save_two_step: boolean, signup_bonus: boolean, qr_code: string,
        pro_signup: boolean,
        go_to: (step:t_states)=>void, get_enc_url: ()=>string)=>
    {
        const _this = this;
        this.last_email = email;
        this.active_process = etask(function*(){
            try {
                if (!is_valid_email(email))
                    return;
                if (_this.validate_password(password))
                    return;
                _this.change_last_process_error('');
                _this.change_status('in_progress');
                const body = {username: email, password,
                    save_two_step} as object_of<any>;
                if (!news)
                    body.unsubscribe = 1;
                const {ignore_countries} = hopt.recaptcha || {};
                const mtcaptcha = hopt.mtcaptcha;
                let token;
                let type_c = 'google';
                if (mtcaptcha.enable)
                {
                    // @ts-ignore
                    if (!window.mtcaptcha)
                    {
                        const err = new Error();
                        // @ts-ignore
                        err.hola_info = {
                            response_text: 'load_recaptcha',
                            status: 401,
                        };
                        throw err;
                    }
                    token = yield _this.get_token();
                    type_c = 'mtcaptcha';
                    if (!token)
                    {
                        const err = new Error();
                        // @ts-ignore
                        err.hola_info = {
                            response_text: 'recaptcha',
                            status: 401,
                        };
                        throw err;
                    }
                    body.recaptcha = token;
                    body.type_c = type_c;
                }
                else if (!ignore_countries
                    || ignore_countries.indexOf(hopt.user_country)==-1)
                {
                    clearTimeout(_this.recaptcha_stuck);
                    _this.recaptcha_stuck = setTimeout(()=>{
                        perr({id: 'www_signup_stuck_recaptcha'});
                    }, 10000);
                    body.type_c = type_c;
                    // @ts-ignore
                    body.recaptcha = yield recaptcha.new_token('signup');
                    clearTimeout(_this.recaptcha_stuck);
                    clearTimeout(_this.recaptcha_long_stuck);
                }
                let qs = {no_redirect: 1} as object_of<any>;
                if (signup_bonus)
                    qs.signup_bonus = 1;
                if (qr_code)
                    qs.qr_code = qr_code;
                if (pro_signup)
                    qs.pro_signup = pro_signup;
                yield fetch(up+'/auth/basic/signup?'+zescape.qs(qs),
                    {method: 'POST', body});
                perr({id: 'www_signup_success', info: {email}});
                _this.change_status('ready');
                go_to('signup_check_email');
            } catch(e){
                if (e=='recaptcha_cancel')
                    return void _this.change_status('ready');
                console.error(e);
                let err_type = e.hola_info && (e.hola_info.data ||
                    e.hola_info.response_text);
                if (err_type=='invalid password')
                {
                    _this.change_last_process_error('weak_password');
                    _this.change_status('ready');
                    return;
                }
                if (['abuse_ip', 'recaptcha', 'load_recaptcha', 'bad_email',
                    'domain_blacklisted',
                    'friendly_signup'].includes(err_type))
                {
                    _this.change_last_process_error(err_type);
                    _this.change_status('ready');
                    return;
                }
                if (err_type=='email_already_used')
                {
                    const ret = yield _this.check_password(email, password);
                    if (ret=='unverified_two_step')
                    {
                        _this.change_status('waiting_for_two_step');
                        return;
                    }
                    if (ret!==true)
                    {
                        // XXX dmitriiz: but user can network response and
                        // see actual error
                        _this.change_last_process_error('unknown');
                        _this.change_status('ready');
                        return;
                    }
                    yield _this.login_done(email, get_enc_url);
                }
                _this.change_last_process_error('unknown');
                _this.change_status('ready');
            }
        });
    };
}

export const login_process = new Login_process();

export const is_state_with_banner = (state:t_states)=>{
    return state=='login_buttons' || state=='signup_buttons'
        || state=='login_with_email' || state=='two_factor'
        || state=='signup_with_email' || state=='set_password';
};

export const open_homepage = ()=>{
    // XXX: defined in vpn_config
    // why: there is link to open /faq
    // we have to go back to /vpn_config
    const search = window.location.search;
    const global_homepage = storage.get('global_homepage') || '';
    const next = global_homepage ? global_homepage : '/';
    if (search && search.indexOf('logo_disabled')>-1)
        return;
    window.location.href = next;
};

interface i_ensure_login_opt {
    embed_hola_browser?: boolean;
    readonly_access?: boolean;
    guest_available?: boolean;
    next?: string;
    hash?: string;
    simple?: boolean;
    logo_disabled?: boolean;
    email_verified?: boolean;
}

export const ensure_email_verified = user=>{
    if (!user || user.verified || !user.emails || !user.providers &&
        user.provider!='basic')
    {
        return {res: 'ok', user};
    }
    return {res: 'email_not_verified', user};
};

export const ensure_login = (opt:i_ensure_login_opt)=>etask(function*(){
    let res = yield get_user({source: 'login_ensure',
        embed_hola_browser: opt.embed_hola_browser});
    if (!res.user || res.user.disable_account_changes && !opt.readonly_access)
    {
        if (opt.guest_available)
            return {res: 'ok', user: {hola_uid: 'guest', is_guest: true}};
        let next = opt.next || (opt.hash ?
            location.href.replace(/#.*$/, '')+opt.hash : location.href);
        if (opt.simple)
        {
            const qs_o = qs_parse_url(location.href, {safe: true});
            if (opt.logo_disabled)
                qs_o.logo_disabled = '1';
            const new_url = '/login?'+zescape.qs({...qs_o, next: next});
            if (opt.embed_hola_browser)
            {
                // @ts-ignore
                if (window.global_is_internet_connected)
                {
                    // @ts-ignore
                    window.chrome.send('send_command', ['open_url', new_url]);
                }
            }
            else
                location.href = new_url;
            return {res: 'redirect', user: null};
        }
        return {res: 'need_login', user: null};
    }
    if (!opt.email_verified)
        return {res: 'ok', user: res.user};
    return yield ensure_email_verified(res.user);
});
